import { CartUpdateEvent } from '@theme/events';

/**
 * Candy's free shipping quick add (BUBS pouch) inside the cart drawer / cart page.
 * Adds the variant via the AJAX cart API, then fires Horizon's cart:update event with the
 * re-rendered cart sections so the drawer, cart page, bubble and progress bar all refresh.
 */
class FreeShipUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.#onSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.#onSubmit);
  }

  #onSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    const errorEl = this.querySelector('.fs-upsell__error');
    if (errorEl) errorEl.hidden = true;

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
      .filter(Boolean);
    const routes = (window.Theme && window.Theme.routes) || {};
    const addUrl = routes.cart_add_url || '/cart/add.js';
    const cartUrl = `${routes.cart_url || '/cart'}.js`;

    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(form.elements.namedItem('id').value), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');

      const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.dispatchEvent(
        new CartUpdateEvent({}, 'free-ship-upsell', {
          source: 'free-ship-upsell',
          itemCount: cart.item_count,
          sections: data.sections,
        })
      );
    } catch (error) {
      console.error(error);
      if (errorEl) {
        errorEl.textContent = error instanceof Error ? error.message : 'Could not add to cart';
        errorEl.hidden = false;
      }
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('free-ship-upsell')) customElements.define('free-ship-upsell', FreeShipUpsell);
